import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import Pill from "components/Pill";

import CategoryPillsSkeleton from "./components/CategoryPillsSkeleton";

const CategoryPills = ({ items, loading }) => {
  if (!items || loading) return <CategoryPillsSkeleton limit={4} />;

  return (
    <Grid container spacing={2} style={{ marginBottom: 40 }}>
      {items.map((item) => (
        <Grid key={`pill-${item.id}`} item xs={6} sm={3}>
          <Pill item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

CategoryPills.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
};

export default CategoryPills;
